module.exports = __webpack_public_path__ + "static/media/login_bg_8_1920x1080.f6daefdc.jpg";